// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.processing-sort-anchor {
  display: inline-flex;
  position: relative;
}

.processing-sort-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  max-width: min(258px, 42vw);
  padding: 0 10px;
  border: 1px solid #dbe2e4;
  border-radius: 10px;
  background: #fbfcfa;
  color: #435451;
  box-shadow: 0 1px 2px rgba(29, 47, 42, .05);
  cursor: pointer;
  font: inherit;
  transition: border-color .16s ease, background-color .16s ease, transform .16s ease;
}

.processing-sort-trigger:hover,
.processing-sort-trigger.is-open {
  border-color: #a8b9af;
  background: #f2f6f2;
}

.processing-sort-trigger:active { transform: translateY(1px); }
.processing-sort-trigger:focus-visible {
  outline: 2px solid #426c57;
  outline-offset: 2px;
}

.processing-sort-current {
  overflow: hidden;
  color: #293b35;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.processing-sort-chevron {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
  color: #7a8982;
}

.processing-sort-menu {
  position: fixed;
  z-index: 16000;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 7px;
  border: 1px solid #dce4df;
  border-radius: 14px;
  background: #fcfdfb;
  box-shadow: 0 18px 46px rgba(25, 43, 35, .19), 0 3px 9px rgba(25, 43, 35, .08);
  color: #263832;
  box-sizing: border-box;
  animation: processing-sort-arrive .13s ease-out;
}

.processing-sort-menu-heading {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  padding: 9px 10px 10px;
  border-bottom: 1px solid #edf1ed;
  color: #2f4139;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  font-weight: 750;
  letter-spacing: .015em;
}

.processing-sort-menu-hint {
  color: #8a9690;
  font-size: calc(10px + var(--kds-font-delta, 0px));
  font-weight: 550;
  letter-spacing: normal;
}

.processing-sort-option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 55px;
  margin-top: 3px;
  padding: 8px 10px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.processing-sort-option:hover,
.processing-sort-option:focus-visible {
  outline: none;
  background: #f1f5f0;
}

.processing-sort-option:focus-visible {
  box-shadow: inset 0 0 0 2px #72917d;
}

.processing-sort-option.is-selected {
  background: #eaf1eb;
}

.processing-sort-option.is-unavailable {
  opacity: .5;
  cursor: not-allowed;
}

.processing-sort-trigger:disabled {
  opacity: .6;
  cursor: not-allowed;
  transform: none;
}

.processing-sort-radio {
  display: grid;
  width: 17px;
  height: 17px;
  flex: 0 0 auto;
  place-items: center;
  border: 1.5px solid #b6c2ba;
  border-radius: 50%;
  box-sizing: border-box;
}

.processing-sort-option.is-selected .processing-sort-radio {
  border-color: #477257;
}

.processing-sort-radio > span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #477257;
}

.processing-sort-option-copy {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 3px;
}

.processing-sort-option-label {
  color: #31443a;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  font-weight: 700;
  line-height: 1.2;
}

.processing-sort-option-detail {
  overflow: hidden;
  color: #7b8981;
  font-size: calc(10.5px + var(--kds-font-delta, 0px));
  font-weight: 450;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.processing-sort-check {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  color: #477257;
}

.processing-sort-menu.is-dark {
  border-color: #43544d;
  background: #1f2d28;
  color: #e3ebe5;
  box-shadow: 0 18px 46px rgba(0, 0, 0, .4), 0 3px 9px rgba(0, 0, 0, .2);
}

.processing-sort-menu.is-dark .processing-sort-menu-heading { border-color: #34453d; color: #e2ebe4; }
.processing-sort-menu.is-dark .processing-sort-menu-hint,
.processing-sort-menu.is-dark .processing-sort-option-detail { color: #a1b0a7; }
.processing-sort-menu.is-dark .processing-sort-option-label { color: #e0e9e2; }
.processing-sort-menu.is-dark .processing-sort-option:hover,
.processing-sort-menu.is-dark .processing-sort-option:focus-visible { background: #2b3b33; }
.processing-sort-menu.is-dark .processing-sort-option.is-selected { background: #32483a; }
.processing-sort-menu.is-dark .processing-sort-radio { border-color: #71877a; }
.processing-sort-menu.is-dark .processing-sort-option.is-selected .processing-sort-radio { border-color: #9bc4a7; }
.processing-sort-menu.is-dark .processing-sort-radio > span { background: #9bc4a7; }
.processing-sort-menu.is-dark .processing-sort-check { color: #9bc4a7; }

@keyframes processing-sort-arrive {
  from { opacity: 0; transform: translateY(-3px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (max-width: 600px) {
  .processing-sort-trigger { gap: 6px; padding: 0 8px; max-width: 190px; }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/KDS/components/ProcessingSortMenu.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,eAAe;EACf,aAAa;EACb,mFAAmF;AACrF;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,kCAAkC,0BAA0B,EAAE;AAC9D;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8EAA8E;EAC9E,cAAc;EACd,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,sBAAsB;EACtB,gCAAgC;EAChC,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,OAAO;EACP,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oDAAoD;EACpD,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,sEAAsE;AACxE;;AAEA,8DAA8D,qBAAqB,EAAE,cAAc,EAAE;AACrG;+DAC+D,cAAc,EAAE;AAC/E,8DAA8D,cAAc,EAAE;AAC9E;sEACsE,mBAAmB,EAAE;AAC3F,oEAAoE,mBAAmB,EAAE;AACzF,uDAAuD,qBAAqB,EAAE;AAC9E,2FAA2F,qBAAqB,EAAE;AAClH,8DAA8D,mBAAmB,EAAE;AACnF,uDAAuD,cAAc,EAAE;;AAEvE;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,2BAA2B,QAAQ,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACzE","sourcesContent":[".processing-sort-anchor {\n  display: inline-flex;\n  position: relative;\n}\n\n.processing-sort-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 36px;\n  max-width: min(258px, 42vw);\n  padding: 0 10px;\n  border: 1px solid #dbe2e4;\n  border-radius: 10px;\n  background: #fbfcfa;\n  color: #435451;\n  box-shadow: 0 1px 2px rgba(29, 47, 42, .05);\n  cursor: pointer;\n  font: inherit;\n  transition: border-color .16s ease, background-color .16s ease, transform .16s ease;\n}\n\n.processing-sort-trigger:hover,\n.processing-sort-trigger.is-open {\n  border-color: #a8b9af;\n  background: #f2f6f2;\n}\n\n.processing-sort-trigger:active { transform: translateY(1px); }\n.processing-sort-trigger:focus-visible {\n  outline: 2px solid #426c57;\n  outline-offset: 2px;\n}\n\n.processing-sort-current {\n  overflow: hidden;\n  color: #293b35;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  font-weight: 650;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.processing-sort-chevron {\n  width: 14px;\n  height: 14px;\n  flex: 0 0 auto;\n  color: #7a8982;\n}\n\n.processing-sort-menu {\n  position: fixed;\n  z-index: 16000;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 7px;\n  border: 1px solid #dce4df;\n  border-radius: 14px;\n  background: #fcfdfb;\n  box-shadow: 0 18px 46px rgba(25, 43, 35, .19), 0 3px 9px rgba(25, 43, 35, .08);\n  color: #263832;\n  box-sizing: border-box;\n  animation: processing-sort-arrive .13s ease-out;\n}\n\n.processing-sort-menu-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 12px;\n  padding: 9px 10px 10px;\n  border-bottom: 1px solid #edf1ed;\n  color: #2f4139;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  font-weight: 750;\n  letter-spacing: .015em;\n}\n\n.processing-sort-menu-hint {\n  color: #8a9690;\n  font-size: calc(10px + var(--kds-font-delta, 0px));\n  font-weight: 550;\n  letter-spacing: normal;\n}\n\n.processing-sort-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  min-height: 55px;\n  margin-top: 3px;\n  padding: 8px 10px;\n  border: 0;\n  border-radius: 9px;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.processing-sort-option:hover,\n.processing-sort-option:focus-visible {\n  outline: none;\n  background: #f1f5f0;\n}\n\n.processing-sort-option:focus-visible {\n  box-shadow: inset 0 0 0 2px #72917d;\n}\n\n.processing-sort-option.is-selected {\n  background: #eaf1eb;\n}\n\n.processing-sort-option.is-unavailable {\n  opacity: .5;\n  cursor: not-allowed;\n}\n\n.processing-sort-trigger:disabled {\n  opacity: .6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.processing-sort-radio {\n  display: grid;\n  width: 17px;\n  height: 17px;\n  flex: 0 0 auto;\n  place-items: center;\n  border: 1.5px solid #b6c2ba;\n  border-radius: 50%;\n  box-sizing: border-box;\n}\n\n.processing-sort-option.is-selected .processing-sort-radio {\n  border-color: #477257;\n}\n\n.processing-sort-radio > span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #477257;\n}\n\n.processing-sort-option-copy {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.processing-sort-option-label {\n  color: #31443a;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.processing-sort-option-detail {\n  overflow: hidden;\n  color: #7b8981;\n  font-size: calc(10.5px + var(--kds-font-delta, 0px));\n  font-weight: 450;\n  line-height: 1.3;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.processing-sort-check {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 auto;\n  color: #477257;\n}\n\n.processing-sort-menu.is-dark {\n  border-color: #43544d;\n  background: #1f2d28;\n  color: #e3ebe5;\n  box-shadow: 0 18px 46px rgba(0, 0, 0, .4), 0 3px 9px rgba(0, 0, 0, .2);\n}\n\n.processing-sort-menu.is-dark .processing-sort-menu-heading { border-color: #34453d; color: #e2ebe4; }\n.processing-sort-menu.is-dark .processing-sort-menu-hint,\n.processing-sort-menu.is-dark .processing-sort-option-detail { color: #a1b0a7; }\n.processing-sort-menu.is-dark .processing-sort-option-label { color: #e0e9e2; }\n.processing-sort-menu.is-dark .processing-sort-option:hover,\n.processing-sort-menu.is-dark .processing-sort-option:focus-visible { background: #2b3b33; }\n.processing-sort-menu.is-dark .processing-sort-option.is-selected { background: #32483a; }\n.processing-sort-menu.is-dark .processing-sort-radio { border-color: #71877a; }\n.processing-sort-menu.is-dark .processing-sort-option.is-selected .processing-sort-radio { border-color: #9bc4a7; }\n.processing-sort-menu.is-dark .processing-sort-radio > span { background: #9bc4a7; }\n.processing-sort-menu.is-dark .processing-sort-check { color: #9bc4a7; }\n\n@keyframes processing-sort-arrive {\n  from { opacity: 0; transform: translateY(-3px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@media (max-width: 600px) {\n  .processing-sort-trigger { gap: 6px; padding: 0 8px; max-width: 190px; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
